import React, { Component } from 'react';
import { hideModal, MODAL_ADD_STUDENT_ROOM } from '../../../../../modules/modals';
import { connect } from 'react-redux'
import Modal from 'react-modal';
import PropTypes from 'prop-types'
import { Radio, Table } from 'antd';
import { ExclamationOutlined, WarningOutlined, CheckOutlined } from '@ant-design/icons';
import './style.scss';
import { searchStudents, addRoomStudents } from '../../../actions';
import Spiner from '../../../../helpers/Spiner/Spiner';


class FormAddStudentRoom extends Component {
  static contextTypes = {formatMessage: PropTypes.any};
  constructor(props) {
    super(props)
    this.state = {
      search_type: 'email',
      search_value: '',
      search_students: [],
      added_students: [],
      is_search: false,
      selectedRowKeys: [],
      confirm: false,
      spinner: true,
    }
  }
  
  handleClose = () => {
    const { hideModal } = this.props;
    hideModal({ modalType : MODAL_ADD_STUDENT_ROOM});
    this.setState({
      search_type: 'email',
      search_value: '',
      search_students: [],
      is_search: false,
      selectedRowKeys: [],
      confirm: false,
    })
  }

  onSelectChange = selectedRowKeys => {
    this.setState({ selectedRowKeys });
  };

  getTitle = () => {
    const {formatMessage} = this.context
    let text = "frmTitleAddStudentToClassroom"
    return <div className="create-dialog-modal-content__title">{formatMessage(text)}</div>;
  }

  validateEmail(email) {
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  }

  search = async (e) => {
    e.preventDefault();
    const {search_type, search_value} = this.state;
    const { students } = this.props;
    if(!search_value){
      this.setState({
        search_error: 'is required'
      })
      return;
    }

    if(search_type == 'email'){
      const tmp_email = search_value.replace(/\s/g, '').split(',');
      
  
      if(tmp_email.some(email => {
        if(email && !this.validateEmail(email)){
          return true
        }
      })){
        this.setState({
          search_error: 'Email is not valid'
        })
        return;
      }
    }

    let result = await searchStudents({
      search_type,
      search_value: search_value.replace(/\s/g, ''),
    });

    

    const ids = students.map(i => i.id);

    this.setState({
      is_search: true,
      search_students: result.filter(i => ids.indexOf(i.id) < 0),
      added_students: result.filter(i => ids.indexOf(i.id) > -1)
    });
  }

  addStudent = async () => {
    const { search_students, selectedRowKeys } = this.state;
    const { room, students } = this.props;

    if(!selectedRowKeys.length){
      return;
    }

    const students_add = search_students.filter((item, index) => selectedRowKeys.indexOf(index) > -1);
    
    await this.props.addRoomStudents({
      room_id: room.id,
      students: students_add.map(item => ({...item, is_done: 0})),
    });

    this.setState({confirm: true})

  }

  render() {
    const {formatMessage} = this.context
    const { zIndex } = this.props;
    const {search_type, is_search, search_students, selectedRowKeys, added_students, confirm} = this.state;
    const columns = [
      {
        title: formatMessage('tableStudentFirstName'),
        dataIndex: 'firstname',
        key: 'firstname',
      },
      {
        title: formatMessage('tableStudentLastName'),
        dataIndex: 'lastname',
        key: 'lastname',
      },
      {
        title: formatMessage('tableStudentEmail'),
        dataIndex: 'email',
        key: 'email',
      }
    ];

    const rowSelection = {
      selectedRowKeys,
      onChange: this.onSelectChange,
    };
    const hasSelected = selectedRowKeys.length > 0;

    return (
      <Modal
          isOpen = {true}
          style = {{
              overlay : {zIndex},
          }}
          onRequestClose={this.handleClose}
          overlayClassName = "custom-modal"
          className = "custom-modal-content create-dialog-modal-content FormAddStudentRoom"
      >
          <div className="create-dialog-modal-content__header">
              {
                this.getTitle()
              }
              <div
                  onClick={this.handleClose}
                  className="create-dialog-modal-content__close"
              ></div>
          </div>
          <div className="create-dialog-modal-content__body">
            {!is_search && !confirm &&<form className="create-dialog-form" onSubmit={this.search}>
               <div className="row mb-5">
                <label>{formatMessage('txtAddStudentBy')}:</label>
                <Radio.Group onChange={(e) => {
                  this.setState({search_type: e.target.value});
                }} value={search_type}>
                  <Radio value={'email'}>
                    {formatMessage('txtAddByEmail')}
                  </Radio>
                  <Radio value={'firstname'}>
                    {formatMessage('txtAddByFirstname')}
                  </Radio>
                  <Radio value={'lastname'}>
                    {formatMessage('txtAddByLastname')}
                  </Radio>
                </Radio.Group>
                <textarea placeholder="Example: student@gmail.com" value={this.state.search_value} onChange={(e)=> {
                  this.setState({
                    search_value: e.target.value,
                    search_error: ''
                  });
                }}>
                </textarea>
                {this.state.search_error ? <span className="error">{this.state.search_error}</span> : null}
                <p>{formatMessage('txtInformationTipAddStudents')}</p>
              </div>
             
              <div className="create-dialog-form__group flex">
                <button className="btn btn-warning mr-auto" type="button" onClick={() => {
                  this.handleClose();
                }}>{formatMessage('btnModalCancel')}</button>
                <button className="btn btn-primary" type="submit">{formatMessage('btnModalNext')}</button>
              </div>
            </form>}
            {is_search && !confirm && <div className="row mb-5 create-dialog-form">
              {search_students.length ? <div className="message-info">
                <ExclamationOutlined /> <div>{formatMessage('txtInfoSucessStudentImport')}</div>
              </div> : 
                added_students.length ? 
                 <div className="students-added" style={{marginBottom: 30,}}>
                    <div className="message-warning" style={{marginBottom: 10}}>
                      <WarningOutlined /> <div>{formatMessage('txtInfoStudentAdded')}</div>
                    </div>
                    <ul style={{marginLeft: 50,}}>
                      {added_students.map(st => <li>{st.firstname} {st.lastname}</li>)}
                    </ul>
                 </div>
                :
                <div className="message-warning">
                  <WarningOutlined /> <div>{formatMessage('txtInfoWarningStudentImport')}</div>
                </div>
              }
              {search_students.length ? <div style={{height: 300, overflow: 'auto', width: '100%'}}><Table rowSelection={rowSelection} dataSource={search_students} columns={columns} bordered pagination={false} /></div> : null}
              <div className="create-dialog-form__group flex" style={{marginTop: '20px'}}>
                <button className="btn btn-warning mr-auto" type="button" onClick={() => {
                  this.setState({is_search: false});
                }}>{formatMessage('btnModalCancel')}</button>
                {search_students.length ? <button className="btn btn-primary" onClick={this.addStudent} type="button">{formatMessage('btnModalAddStudent')}</button> : null}
              </div>
            </div>}
            {confirm && <div className="row mb-5 create-dialog-form">
              <div className="message-info confirm">
                <CheckOutlined/> <div>{formatMessage('txtInfoSucessStudentAdded')}</div>
              </div>
              <div className="create-dialog-form__group flex" style={{marginTop: '20px'}}>
                <button className="btn btn-primary ml-auto" onClick={this.handleClose} type="button">{formatMessage('btnModalOk')}</button>
              </div>
            </div>}
          </div>
      </Modal>
    );
  }
}


const mapStateToProps = (state, ownProps) => ({
  room: state.rooms.item,
  students: state.rooms.students,
})

const mapDispatchToProps = {
  hideModal,
  addRoomStudents,
}

export default connect(mapStateToProps, mapDispatchToProps)(FormAddStudentRoom)



// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/RoomsAndStudents/Students/components/FormAddStudentRoom/index.jsx